/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * @module bulb-image/bulbimage
 */
import { Plugin } from 'ckeditor5';
import BulbImageEditing from './bulbimageediting';
import BulbLinkImage from './bulb-link-image/bulblinkimage';
import BulbImageUI from './bulbimageui';
import BulbImageToolbar from './bulbimagetoolbar';

/**
 * The image plugin for Bulb's CKEditor.
 *
 * @extends Plugin
 */
export default class BulbImage extends Plugin {

  /**
   * @inheritDoc
   */
  public static get pluginName(): string {
    return 'BulbImage' as const;
  }

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbImageEditing, BulbImageUI, BulbImageToolbar, BulbLinkImage] as const;
  }
}
